<template>
  <div>
    <div class="user-content" style="justify-content: space-between !important">
      <p
        @click="goToProfile($event, item.user_data.name)"
        style="display: flex"
        class="card-user-name"
      >
        <img
          v-if="item.user_data.profile_image"
          class="card-user-name"
          style="height: 40px; width: 40px; border-radius: 40px"
          :src="getLink(item.user_data.profile_image)"
          alt=""
        />
        <!-- @click="goToProfile($event, trade_detail.posted_by_name)" -->
        <v-avatar
          class="card-user-name"
          style="background-color: lightblue"
          size="40"
          v-if="!item.user_data.profile_image"
        >
          <span
            class="card-user-name"
            style="color: #333333; font-weight: 700; font-size: 15px"
            >{{ item.user_data.name | reduceToInitials }}</span
          >
        </v-avatar>
        <span style="padding: 10px" class="card-user-name user-name">{{
          item.user_data.name
        }}</span>
      </p>
      <!-- {{ item.created }} -->
      <span style="padding: 10px">
        <span class="comment-date">
          {{ getTime(item.created) }}
        </span>
        <!-- {{typeof(item.user_data.id)}},v{{typeof(loggedInProfile.profile_id)}} -->
        <v-menu
          offset-y
          v-if="
            parseInt(item.user_data.id) != parseInt(loggedInProfile.profile_id)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              height="40"
              class="ml-2 py-5"
              style="min-width: 0px !important; padding: 0 0px !important"
            >
              <v-icon color="#2d8cff">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                @click="
                  toggleBlockUser({
                    show: true,
                    block_by: loggedInProfile.profile_id,
                    block_to: item.user_data.id,
                  })
                "
                >Report & Block User</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
    </div>
    <!-- {{ trade_detail }} -->
    <div class="comment">
      <LinkPreview
        v-if="getUrl(item.comment_text)"
        :preview_url="getUrl(item.comment_text)"
      ></LinkPreview>
      <p v-linkified>{{ item.comment_text }}</p>
    </div>
    <!-- {{ comment[comment.length - 1].id == item.id }} -->
    <v-divider
      v-if="comment[comment.length - 1].id != item.id"
      style="padding: 5px 0px !important"
    >
    </v-divider>
    <!-- <report-and-block-user
      :loggedInProfile="loggedInProfile"
      :profile_object="item.user_data"
    ></report-and-block-user> -->
  </div>
</template>

<script>
import LinkPreview from "@/components/Trade/LinkPreview.vue";
import { mapActions } from "vuex";
import dayjs from "dayjs";

export default {
  name: "CommentCard",

  components: {
    LinkPreview,
    // ReportAndBlockUser: () =>
    //   import("@/components/BlockUser/ReportAndBlockUser"),
  },

  props: {
    item: {
      type: Object,
    },
    trade_detail: {
      type: Object,
    },
    comment: {
      type: Array,
    },
  },
  data() {
    return {
      loggedInProfile: {},
    };
  },
  computed: {
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      return Number(user_id) === Number(this.item.user_data.user);
    },
  },
  created() {
    this.loggedInProfile["user_id"] = localStorage.getItem("user_id");
    this.loggedInProfile["profile_id"] = localStorage.getItem("profile_id");
  },
  mounted() {},

  methods: {
    ...mapActions({
      toggleBlockUser: "blockUser/toggleModal",
    }),
    getLink(link) {
      return link;
    },
    getTime(value) {
      return dayjs(value).format("h:mm A D MMM");
    },
    goToProfile(e, name) {
      // console.log(name);
      // console.log("click", e.target.className.split(" "), name);

      if (
        e.target.className.split(" ")[0] === "card-user-name" ||
        e.target.className.split(" ")[1] === "card-user-name"
      ) {
        // console.log("is same user");
        if (this.is_same_user) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: { id: this.item.user_data.user, name: name },
          });
        }
      }
      // }
    },
    getUrl(text) {
      const string = text;
      console.log(text, "text");

      const matches = string.match(/\bhttps?:\/\/\S+/gi);
      console.log(matches, "matches");
      if (matches && matches.length >= 1) {
        return matches[0];
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.comment-date {
  font-size: 10px;
}
.card-user-name {
  cursor: pointer;
}
.user-content {
  display: flex !important;
  justify-content: space-between !important;
}
.user-image {
  object-fit: cover;
  cursor: pointer;
}
span {
  font-size: 14px;
  line-height: 19px;
  color: rgba(51, 51, 51, 0.87);
}
.comment {
  padding: 0px 5px;
  /* padding-bottom: 0; */
}
@media only screen and (max-width: 768px) {
  .comment-date {
    font-size: 8px;
  }
}
</style>
